// router
// import router from './router';
import router from './router/bizgain-router';

import { PageNotFoundRoute } from './router/pageNotFound';
import { RoimaticService } from 'AppServices/roimaticService';
import { LoginRoute } from './features/login/router';
import { AppService } from 'AppServices/appService';
const { getCurrencyInfo, getCurrencyInfoByRegion } = new AppService();
import { bizgainOnboardingRoutes, launchState } from 'Features/bizgainOnboarding/constants';
import { assignSubsequentFlowMeta } from 'Features/bizgainOnboarding/helpers/subSequentCampaignHelper';
import { assignPostSignUpInitialFlowMeta, redirectToBusinessProfile, getSignupRouteFromLaunchState } from 'Features/bizgainOnboarding/helpers/commonHelper';
import { state as bizgainNonPersistedState, getters as bizgainNonPersistedGetters, actions as bizgainNonPersistedActions, mutations as bizgainNonPersistedMutations } from 'Features/bizgainOnboarding/store/Modules/NonPersistedStore/NonPersistedStore.js';
import { state as bizgainPersistedState, getters as bizgainPersistedGetters, actions as bizgainPersistedActions, mutations as bizgainPersistedMutations } from 'Features/bizgainOnboarding/store/Modules/PersistedStore/PersistedStore.js';
import { getLaunchStateFromCurrentRoute, getRouteFromLaunchState } from 'Features/bizgainOnboarding/helpers/draftCampaignHelper';
import { vuePresist } from 'Store/plugin/vuePresist';
import { homeRoutes } from 'Features/home-mobile/constants';
import { ApiService } from './features/bizgainOnboarding/services/apiService';
import { filterObjectByKeys } from './helpers/helpers'
import { countryCode } from './constants/PortalConfig';
import Bugsnag from '@bugsnag/browser';
const bizgainApiService = new ApiService();

const isBpLevelRoute = (destinationRoute) => {
  return (
    destinationRoute.path.startsWith('/app')
  );
};

const isRegionSet = () => {
  return localStorage.getItem('region')
}

const isCampaignLevelRoute = (destinationRoute) => {
  return (
    destinationRoute.path.startsWith('/app') && (destinationRoute.path.includes('/campaign') || destinationRoute.path.includes('/editCampaign'))
  );
}

const requiresAuth = (to) => {
  return to.matched.some((record) => record.meta.requiresAuth)
}

/* Redirection methods */
const redirectToNotFoundPage = (from, redirect, next) => {
  let redirectRoute = {
    name: PageNotFoundRoute.name,
    params: [from.path], // https://github.com/vuejs/vue-router/issues/724#issuecomment-663315290
    replace: true
  };
  redirect(from, redirectRoute, next);
  return;
};

const redirectoToCountrySelector = (to, from, redirect, next) => {
  let redirectRoute = {
    name: 'countrySelector',
    query: { redirect: to.fullPath }
  };
  redirect(from, redirectRoute, next);
  return;
}

const redirectToLoginPage = (to, from, redirect, next) => {
  let redirectRoute = {
    name: LoginRoute.name,
    query: { redirect: to.fullPath }
  };
  redirect(from, redirectRoute, next);
  return;
};

export const GlobalRouterGuard = {
  configure(nProgress, i18n, store) {
    const isUserAuthorized = () => {
      return store.getters.user != null || localStorage.getItem('accessToken') != null;
    }
    const setupBusinessProfile = async (selectedBusinessProfile) => {
      let roimaticService = new RoimaticService(selectedBusinessProfile.id);
      let response = await Promise.all([roimaticService.getRoimaticConfiguration(), getCurrencyInfo(selectedBusinessProfile.currencyId, selectedBusinessProfile.id)]);
      let roimaticConfiguration = response[0];
      let currencyInfo = response[1];
      if (roimaticConfiguration &&
        roimaticConfiguration.business &&
        roimaticConfiguration.business.region)
      {
        store.dispatch('setRegion', roimaticConfiguration.business.region);
      }
      await store.dispatch('setRoimaticConfiguration', roimaticConfiguration);
      await store.dispatch('setCurrencyInfo', currencyInfo);
      await store.dispatch('setCurrencyCode', currencyInfo.code);
      await store.dispatch('setTimezoneId', selectedBusinessProfile.timezoneId);
    };
    /*Methods*/
    const validateCampaign = async (businessProfileId, campaignId, from, redirect, next) => {
      if (isNaN(campaignId)) {
        redirectToNotFoundPage(from, redirect, next);
      }
      let payload = {
        businessProfileId: parseInt(businessProfileId),
        campaignId: parseInt(campaignId),
        disableErrorHandling: true
      };
      try {
        await store.dispatch('getRoimaticCampaign', payload);
        await store.dispatch('setSelectedCampaignId', campaignId);
      } catch {
        redirectToNotFoundPage(from, redirect, next);
      }
      let additionalConfigurationSessionId = store.getters.roimaticCampaign && store.getters.roimaticCampaign.additionalConfiguration && store.getters.roimaticCampaign.additionalConfiguration.localBusiness && store.getters.roimaticCampaign.additionalConfiguration.localBusiness.sessionId;
      if (store.getters.sessonId != additionalConfigurationSessionId) {
        await store.dispatch('setSessionId', additionalConfigurationSessionId);
      }
    };

    // only retain [refcode, code] query parameter across routes
    const retainQueryParameters = (from, to, next) => {
      const parameterToRetain = ['refcode', 'code', 'agentid', 'normalFlow'];
      if(!from.query || (from.query !== null && Object.keys(from.query).length === 0)) {
        next();
      } else if (!to.query || (to.query !== null && Object.keys(to.query).length === 0)) {
        let queryParameters = filterObjectByKeys(from.query, parameterToRetain);
        if (queryParameters && Object.keys(queryParameters).length > 0) {
          next({ name: to.name, query: queryParameters, params: to.params });
        } else {
          next();
        }
      } else {
        let toQueryParameters = Object.keys(to.query).filter(key => parameterToRetain.includes(key));
        let fromQueryPrameters = Object.keys(from.query).filter(key => parameterToRetain.includes(key));
        if (fromQueryPrameters.every(elem => toQueryParameters.includes(elem))) {
          next();
        } else {
          let parameters = filterObjectByKeys(Object.assign({}, from.query, to.query), parameterToRetain);
          next({ name: to.name, query: parameters, params: to.params });
        }
      }
    }

    const setBusinessDetailSession = async (sessionId, isSummaryPage = fasle) => {
      try {
        let currentSession = JSON.parse(localStorage.getItem('bizgain-onboarding'));
        let currentSessionId = currentSession &&
                    currentSession.bizgainOnboarding &&
                    currentSession.bizgainOnboarding.businessDetails &&
                    currentSession.bizgainOnboarding.businessDetails.data &&
                    currentSession.bizgainOnboarding.businessDetails.data.sessionId;
        if (sessionId === currentSessionId && !isSummaryPage)
        {
          return;
        }
        let onboardingSession = await bizgainApiService.getBusinessDetailsBySessionId(sessionId);
        if (onboardingSession.launchState > launchState.BUDGET)
        {
          return;
        }
        let params = {
          'isAppFlow': true
        }
        // these all are id based route.
        switch (onboardingSession.launchState)
        {
          case launchState.CREATIVESPREVIEW:
          case launchState.CREATIVESEDIT:
          case launchState.FACEBOOKADPREVIEW:
          case launchState.FACEBOOKADEDIT:
            let templateId = onboardingSession.creativeDetail.selectedTemplateId;
            params.id = templateId;
        }

        var route;
        if (store && store.getters && store.getters.isAutoGeneratedFlow){
          route = bizgainOnboardingRoutes.SetupBusinessInfo;
        }
        else {
          route = getSignupRouteFromLaunchState(onboardingSession.launchState, params);
        }
        localStorage.setItem('lastVisitedRoute', JSON.stringify(route));
        store.commit('setBusinessDetails', onboardingSession);
      } catch(ex) {
        Bugsnag.notify(ex.message);
      }
    }

    const redirect = (from, redirectRoute, next) => {
      // Call NProgress.done() for cancelled navigations
      if (from.name === redirectRoute.name) {
        nProgress.done();
      }
      next(redirectRoute);
    };

    const validateSelectedBusinessProfile = async (
      businessProfileId,
      from,
      redirect,
      next
    ) => {
      let selectedBusinessProfile;
      if (isNaN(businessProfileId)) {
        redirectToNotFoundPage(from, redirect, next);
      } else {
        businessProfileId = parseInt(businessProfileId);
      }

      if (!store && store.getters && store.getters.user) {
        redirectToLoginPage(to, from, redirect, next);
      }

      selectedBusinessProfile = store.getters.user.businessProfiles.find(
        (bp) => bp.id === businessProfileId
      );

      if (!selectedBusinessProfile) {
        redirectToNotFoundPage(from, redirect, next);
      } else if (
        selectedBusinessProfile.currencyId == 0 ||
    !selectedBusinessProfile.currencyId
      ) {
        await fetchUserDetails(store.getters.user);
        selectedBusinessProfile = store.getters.user.find(
          (bp) => bp.id === businessProfileId
        );
      }

      await store.dispatch('setBusinessProfileId', businessProfileId);
      return selectedBusinessProfile;
    };

    const configureBizgainOnboardingStore = () => {
      /*
    Previously the store registration for bizgain was done at bizgain layout / component level
    Due to which store is not available at global level, below block of code will make
    sure that store is available globally for bizgain flavour.
  */
      if (store.getters.isForBizgain) {
        if (!store.hasModule('bizgainOnboardingNonPersisted')) {
          store.registerModule('bizgainOnboardingNonPersisted', {
            state: bizgainNonPersistedState,
            getters: bizgainNonPersistedGetters,
            actions: bizgainNonPersistedActions,
            mutations: bizgainNonPersistedMutations
          });
        }
        if (!store.hasModule('bizgainOnboarding')) {
          store.registerModule('bizgainOnboarding', {
            state: bizgainPersistedState,
            getters: bizgainPersistedGetters,
            actions: bizgainPersistedActions,
            mutations: bizgainPersistedMutations
          });
          vuePresist(store, 'bizgain-onboarding', ['bizgainOnboarding']);
        }
      }
    }
    const validatePortalDetails = async (to, from, redirect, next) => {
      if (!store.getters.portal) {
        await store.dispatch('setPortal');
        if (!store.getters.portal) {
          redirectToNotFoundPage(from, redirect, next);
        }
      }
    }

    const setRegion = async (queryParameters) => {
      let region = 'IN';
      let validRegions = store.getters.validRegions;
      let businessDetails = store.getters.businessDetails;
      if (businessDetails && businessDetails.region)
      {
        region = businessDetails.region;
      }
      else if (queryParameters['region'])
      {
        region = queryParameters['region']
      }
      else if (localStorage.getItem('region'))
      {
        region = localStorage.getItem('region');
      }
      region = validRegions.find(x => x.region == region.toUpperCase()) ? region.toUpperCase() : countryCode.India;
      store.dispatch('setRegion', region);
      var currencyInfo = await getCurrencyInfoByRegion(region);
      await store.dispatch('setCurrencyInfo', currencyInfo[0]);
      await store.dispatch('setCurrencyCode', currencyInfo[0].code);
    }

    const setDocumentTitle = (to, portal) => {
      // Out of the matched routes find the title in the meta of the closest route,
      // The closest route is the last route in a nested route
      var nearestRouteMeta = to.matched
        .slice()
        .reverse()
        .find((r) => r.meta && r.meta.title);

      let portalTitle = 'Bizgain';
      if (portal && portal.portalDefaultConfig) {
        portalTitle =
          JSON.parse(portal.portalDefaultConfig).title ||
          'Bizgain';
      }

      document.title = nearestRouteMeta
        ? `${portalTitle} | ${i18n.t(nearestRouteMeta.meta.title)}`
        : portalTitle;
    }

    // navigation guards before each
    router.beforeEach(async (to, from, next) => {
      nProgress.start();
      if (to.name == PageNotFoundRoute.name) {
        next();
        return;
      }

      await validatePortalDetails(to, from, redirect, next);
      if (process.env.VUE_APP_CAPACITOR_ENVIRONMENT === 'true')
      {
        if (to.name !== homeRoutes.countrySelector.name && !isRegionSet())
        {
          redirectoToCountrySelector(to, from, redirect, next);
          return;
        }

        if (to.name === homeRoutes.countrySelector.name)
        {
          next();
          return;
        }
      } else if (to.name === homeRoutes.countrySelector.name || to.name === homeRoutes.home.name)
      {
        redirectToNotFoundPage(from, redirect, next);
        return;
      }
      // Out of the matched routes find the title in the meta of the closest route,
      // The closest route is the last route in a nested route
      setDocumentTitle(to, store.getters.portal);

      /*
          Previously the store registration for bizgain was done at bizgain layout / component level
          Due to which store is not available at global level, below block of code will make
          sure that store is available globally for bizgain flavour.
      */
      await configureBizgainOnboardingStore();
      await setRegion(to.query);
      if (requiresAuth(to)) {
        if (isUserAuthorized())
        {
          if (isBpLevelRoute(to)) {
            let selectedBusinessProfile = await validateSelectedBusinessProfile(to.params && to.params.businessProfileId,
              from,
              redirect,
              next
            );
            await setupBusinessProfile(selectedBusinessProfile);
            if (isCampaignLevelRoute(to)) {
              if (to.params && to.params.isInitialFlow) {
                assignPostSignUpInitialFlowMeta(to);
              } else {
                assignSubsequentFlowMeta(to);
              }
              let campaignId = to.params && to.params.campaignId;
              await validateCampaign(to.params.businessProfileId, campaignId, from, redirect, next);
              if (!(to.params && to.params.isInitialFlow)) {
                await store.dispatch('setIsInAppCampaign', true);
              }
              let currentLaunchState =
              store.getters.additionalConfiguration &&
              store.getters.additionalConfiguration.localBusiness &&
                store.getters.additionalConfiguration.localBusiness.launchState;
                // The undefined case handles the route /app/{bpId}/campaign/{campaignId}
                // In this case, we redirect to the current launch state of the given roimatic campaign
              if ((currentLaunchState > launchState.BUDGET) && (getLaunchStateFromCurrentRoute(to.name) < launchState.ADACCOUNTSETUPANIMATION)){
                // If current launch state is greater than Budget which means that users has already made the payment, so we should not allow him
                // to access budget and also to previous pages
                let route = getRouteFromLaunchState(currentLaunchState, to.params);
                if (route) {
                  redirect(from, route, next);
                }
                return;
              }
              if ((currentLaunchState != launchState.LAUNCHSUCCESSFUL) && (getLaunchStateFromCurrentRoute(to.name) === undefined || getLaunchStateFromCurrentRoute(to.name) > currentLaunchState)) {
                let route = getRouteFromLaunchState(currentLaunchState, to.params);
                if (route) {
                  redirect(from, route, next);
                }
                return;
              } else {
                retainQueryParameters(from, { name: to.name, query: to.query, params: to.params }, next);
              }
            } else {
              retainQueryParameters(from, { name: to.name, query: to.query, params: to.params }, next);
            }
          }else {
            // Check for valid pattern
            retainQueryParameters(from, { name: to.name, query: to.query, params: to.params }, next);
          }
        } else {
          redirectToLoginPage(to, from, redirect, next);
        }
      } else {
        let isBusinessProfileAvailable = isUserAuthorized() && (store.getters.user && store.getters.user.businessProfiles && store.getters.user.businessProfiles.length > 0);
        if (isBusinessProfileAvailable)
        {
          if (to.path.startsWith('/signup')) {
            redirectToBusinessProfile(store.getters.user, from, redirect, next);
          } else {
            retainQueryParameters(from, { name: to.name, query: to.query, params: to.params }, next);
          }
        } else {
          let isLoadedFromSession = false;
          if (to.query && to.query.sessionId) {
            await setBusinessDetailSession(to.query.sessionId, to.path.includes('/summary'));
            isLoadedFromSession = true;
          }
          await store.dispatch('setBusinessProfileId', null);
          if (to.path.startsWith('/signup')) {
            /*
              Feature: Stepper
              Case 1: Intial pre-signup flow steps are defined in router object.
              Case 2: Post signup flow steps are assigned below
              Case 3: Subsequent campaign flow steps are assigned in above block

              stepCount - Total number of steps
              stepNumber - Current step count indicating a set of pages belonging to a step group.
        */
            let lastVisitedRoute = JSON.parse(
              localStorage.getItem('lastVisitedRoute')
            );
            let isActiveFlow = sessionStorage.getItem('isActiveFlow');
            let bizgainOnboardingLocalStorage = JSON.parse(
              localStorage.getItem('bizgain-onboarding')
            );
            let sessionId =
          bizgainOnboardingLocalStorage &&
          bizgainOnboardingLocalStorage.bizgainOnboarding &&
          bizgainOnboardingLocalStorage.bizgainOnboarding.businessDetails &&
          bizgainOnboardingLocalStorage.bizgainOnboarding.businessDetails
            .data &&
          bizgainOnboardingLocalStorage.bizgainOnboarding.businessDetails.data
            .sessionId;
            let currentLaunchState =
          bizgainOnboardingLocalStorage &&
          bizgainOnboardingLocalStorage.bizgainOnboarding &&
          bizgainOnboardingLocalStorage.bizgainOnboarding.businessDetails &&
          bizgainOnboardingLocalStorage.bizgainOnboarding.businessDetails
            .data &&
          bizgainOnboardingLocalStorage.bizgainOnboarding.businessDetails.data
            .launchState;
            if(to.query && to.query.agentid) {
              let oldBusinessDetails = bizgainOnboardingLocalStorage &&
              bizgainOnboardingLocalStorage.bizgainOnboarding &&
              bizgainOnboardingLocalStorage.bizgainOnboarding.businessDetails &&
              bizgainOnboardingLocalStorage.bizgainOnboarding.businessDetails.data;
              let newBusinessDetails = JSON.parse(JSON.stringify(oldBusinessDetails));
              if(newBusinessDetails){
                newBusinessDetails.queryParameters['agentid'] = to.query.agentid;
              }
              let payload = {
                sessionId: sessionId,
                oldBusinessDetails: oldBusinessDetails,
                newBusinessDetails: newBusinessDetails
              }
              if(oldBusinessDetails && newBusinessDetails){
                await store.dispatch('patchBusinessDetails', payload);
              }
              localStorage.setItem('isAgentFlow', true);
            }

            let normalFlow;
            // from.qery is used to redirected form login page and to.query is used for directly use /signup route
            if((from.query && from.query.normalFlow) || (to.query && to.query.normalFlow)) {
              normalFlow = from.query.normalFlow || to.query.normalFlow;
            }

            let agentId = (bizgainOnboardingLocalStorage &&
          bizgainOnboardingLocalStorage.bizgainOnboarding &&
          bizgainOnboardingLocalStorage.bizgainOnboarding.businessDetails &&
          bizgainOnboardingLocalStorage.bizgainOnboarding.businessDetails
            .data &&
          bizgainOnboardingLocalStorage.bizgainOnboarding.businessDetails.data
            .queryParameters['agentid']);
            if(!agentId){
              agentId = to.query.agentid;
            }
            if(agentId){
              localStorage.setItem('isAgentFlow', true);
            }
            /*
            CASE 1: If is new app flow then re-direct to business details

            CASE 2 - EDGE CASE: If sessionId is not present in all except business details page then redirect to business details page and within pre-signup flow or lastvisited route is confirmation route

            CASE 3: If /bizgain route is used
                  CASE A - EDGE CASE: If user has removed /businessDetails path out of /signup/businessDetails via browser link then go to /businessDetails page.
                  CASE B: If user has entered bp level route then skip confirmation route
                  CASE C: If user has loaded a session from query parameter then skip confirmation route
                  CASE D: If user has previously visted the app and left the flow incompleted then get a confirmation from user.

            CASE 4: If it is existing app flow and user enters entire url via same / different tab
                  CASE A: If user has refreshed the page via browser button or via browser link then go to current page
                  CASE B: If user has entered bp level route then skip confirmation route
                  CASE C: If user has loaded a session from query parameter then skip confirmation route
                  CASE D: If user has entered entire url which is (valid/invalid) route via same / different tab then get a confirmation from user

            isActiveFlow - Used to identify if it is a page refresh or not
            lastVisitedRoute - Stores the last active route visted by user
        */
            //Summary Page
            if (to.name == bizgainOnboardingRoutes.Summary.name){
              retainQueryParameters(from, { name: to.name, query: to.query, params: to.params }, next);
              return;
            }

            //redirect from globalsite
            if((!lastVisitedRoute || lastVisitedRoute.name == bizgainOnboardingRoutes.SetupBusinessInfo.name) && to.name == bizgainOnboardingRoutes.SetupBusinessInfo.name && to.query.website){
              lastVisitedRoute = JSON.stringify({
                name: bizgainOnboardingRoutes.SetupBusinessInfo.name,
                params: { isAppFlow: true }
              });
              localStorage.setItem('lastVisitedRoute', lastVisitedRoute);
              retainQueryParameters(from, { name: to.name, query: to.query, params: to.params }, next);
              return;
            }

            //redirect from campaign
            if((!lastVisitedRoute || lastVisitedRoute.name == bizgainOnboardingRoutes.ExtractBusinessDetails.name) && to.name == bizgainOnboardingRoutes.BusinessDetailsSetupAnimation.name && (to.query.website || to.params.locationid)){
              lastVisitedRoute = JSON.stringify({
                name: bizgainOnboardingRoutes.BusinessDetailsSetupAnimation.name,
                params: { isAppFlow: true }
              });
              localStorage.setItem('lastVisitedRoute', lastVisitedRoute);
              redirect(
                from,
                {
                  name: bizgainOnboardingRoutes.BusinessDetailsSetupAnimation.name,
                  params: { isAppFlow: true },
                  query: Object.assign({}, to.query, from.query)
                },
                next
              );
              return;
            }

            if(to.name == bizgainOnboardingRoutes.SummaryLink.name){
              next();
              return;
            }
            // #CASE - 1
            if (!lastVisitedRoute) {
              //redirect for existing flow
              if(normalFlow || agentId){
                lastVisitedRoute = JSON.stringify({
                  name: bizgainOnboardingRoutes.ExtractBusinessDetails.name,
                  params: { isAppFlow: true }
                });
                localStorage.setItem('lastVisitedRoute', lastVisitedRoute);
                redirect(
                  from,
                  {
                    name: bizgainOnboardingRoutes.ExtractBusinessDetails.name,
                    params: { isAppFlow: true },
                    query: Object.assign({}, to.query, from.query)
                  },
                  next
                );
              }
              else{
                //redirect for shorten flow
                lastVisitedRoute = JSON.stringify({
                  name: bizgainOnboardingRoutes.BusinessDetailsV2.name,
                  params: { isAppFlow: true }
                });
                localStorage.setItem('lastVisitedRoute', lastVisitedRoute);
                redirect(
                  from,
                  {
                    name: bizgainOnboardingRoutes.BusinessDetailsV2.name,
                    params: { isAppFlow: true },
                    query: Object.assign({}, to.query, from.query)
                  },
                  next
                );
              }

              return;
            }

            if (
              lastVisitedRoute.name !=
            bizgainOnboardingRoutes.BusinessDetailsSetupAnimation.name &&
          !sessionId && (to.query.website || to.query.locationid)
            ) {
              lastVisitedRoute = JSON.stringify({
                name: bizgainOnboardingRoutes.BusinessDetailsSetupAnimation.name,
                params: { isAppFlow: true }
              });
              localStorage.setItem('lastVisitedRoute', lastVisitedRoute);
              redirect(
                from,
                {
                  name: bizgainOnboardingRoutes.BusinessDetailsSetupAnimation.name,
                  params: { isAppFlow: true },
                  query: Object.assign({}, to.query, from.query)
                },
                next
              );
              return;
            }

            // #CASE - 2
            if ((lastVisitedRoute.name != bizgainOnboardingRoutes.BusinessDetailsV2.name) &&
              (lastVisitedRoute.name != bizgainOnboardingRoutes.ExtractBusinessDetails.name) &&
              (currentLaunchState && currentLaunchState <= launchState.BUDGET) &&
              !sessionId && !(to.query.website || to.params.locationid)
            ) {
              //redirect for existing flow
              if(normalFlow || agentId){
                lastVisitedRoute = JSON.stringify({
                  name: bizgainOnboardingRoutes.ExtractBusinessDetails.name,
                  params: { isAppFlow: true }
                });
                localStorage.setItem('lastVisitedRoute', lastVisitedRoute);
                redirect(
                  from,
                  {
                    name: bizgainOnboardingRoutes.ExtractBusinessDetails.name,
                    params: { isAppFlow: true }
                  },
                  next
                );
              }
              else{
                if (store && store.getters && store.getters.isAutoGeneratedFlow){
                  //redirect for autogen flow
                  lastVisitedRoute = JSON.stringify({
                    name: bizgainOnboardingRoutes.SetupBusinessInfo.name,
                    params: { isAppFlow: true }
                  });
                  localStorage.setItem('lastVisitedRoute', lastVisitedRoute);
                  redirect(
                    from,
                    {
                      name: bizgainOnboardingRoutes.SetupBusinessInfo.name,
                      params: { isAppFlow: true }
                    },
                    next
                  );
                }
                else{
                  //redirect for shorten flow
                  lastVisitedRoute = JSON.stringify({
                    name: bizgainOnboardingRoutes.BusinessDetailsV2.name,
                    params: { isAppFlow: true }
                  });
                  localStorage.setItem('lastVisitedRoute', lastVisitedRoute);
                  redirect(
                    from,
                    {
                      name: bizgainOnboardingRoutes.BusinessDetailsV2.name,
                      params: { isAppFlow: true }
                    },
                    next
                  );
                }
              }
              return;
            }

            let params = { ...to.params };
            params.isAppFlow = true;
            if (to.name == bizgainOnboardingRoutes.bizgain.name) {
              // #CASE - 3
              if (
                lastVisitedRoute.name == bizgainOnboardingRoutes.ExtractBusinessDetails.name
              ) {
                //redirect for shortenflow flow
                if(to.query.normalFlow || to.query.agentid || from.query.normalFlow || from.query.agentid){
                  redirect(
                    from,
                    {
                      name: bizgainOnboardingRoutes.ExtractBusinessDetails.name,
                      params: lastVisitedRoute.params,
                      query: Object.assign({}, to.query, from.query)
                    },
                    next
                  );
                }
                //redirect for existing flow
                else{
                  redirect(
                    from,
                    {
                      name: bizgainOnboardingRoutes.BusinessDetailsV2.name,
                      params: lastVisitedRoute.params,
                      query: Object.assign({}, to.query, from.query)
                    },
                    next
                  );
                }
              }
              else if (lastVisitedRoute.name == bizgainOnboardingRoutes.BusinessDetailsV2.name){
                //redirect for existing flow
                if(to.query.normalFlow || to.query.agentid || from.query.normalFlow || from.query.agentid){
                  redirect(
                    from,
                    {
                      name: bizgainOnboardingRoutes.ExtractBusinessDetails.name,
                      params: lastVisitedRoute.params,
                      query: Object.assign({}, to.query, from.query)
                    },
                    next
                  );
                }
                else{
                  //redirect for shorten flow
                  redirect(
                    from,
                    {
                      name: lastVisitedRoute.name,
                      params: lastVisitedRoute.params,
                      query: Object.assign({}, to.query, from.query)
                    },
                    next
                  );
                }
              }
              else if (isLoadedFromSession){
                redirect(
                  from,
                  {
                    name: lastVisitedRoute.name,
                    params: lastVisitedRoute.params,
                    query: Object.assign({}, to.query, from.query)
                  },
                  next
                )
              } else {
                redirect(
                  from,
                  {
                    name: bizgainOnboardingRoutes.RouteConfirmation.name,
                    params,
                    query: Object.assign({}, to.query, from.query)
                  },
                  next
                );
              }
              return;
            } else if (!to.params.isAppFlow) {
              // #CASE - 4
              if ((
                isActiveFlow ||
            to.name == lastVisitedRoute.name ||
            (lastVisitedRoute.name == bizgainOnboardingRoutes.ExtractBusinessDetails.name) ||
            (lastVisitedRoute.name == bizgainOnboardingRoutes.BusinessDetailsV2.name)
              ) && !(to.query.website || to.query.locationid)) {
                redirect(
                  from,
                  {
                    name: lastVisitedRoute.name,
                    params: lastVisitedRoute.params,
                    query: Object.assign({}, to.query, from.query)
                  },
                  next
                );
              } else if (isLoadedFromSession){
                redirect(
                  from,
                  {
                    name: lastVisitedRoute.name,
                    params: lastVisitedRoute.params,
                    query: Object.assign({}, to.query, from.query)
                  },
                  next
                )
              } else {
                redirect(
                  from,
                  {
                    name: bizgainOnboardingRoutes.RouteConfirmation.name,
                    params,
                    query: Object.assign({}, to.query, from.query)
                  },
                  next
                );
              }
              return;
            } else {
              if (to.name != bizgainOnboardingRoutes.RouteConfirmation.name) {
                lastVisitedRoute = JSON.stringify({ name: to.name, params });
                localStorage.setItem('lastVisitedRoute', lastVisitedRoute);
              }
            }
            sessionStorage.setItem('isActiveFlow', true);
          } else {
            retainQueryParameters(from, { name: to.name, query: to.query, params: to.params }, next);
          }
        }
      }
      retainQueryParameters(from, { name: to.name, query: to.query, params: to.params }, next);
    });

    // navigation guard after each
    router.afterEach((to) => {
      nProgress.done();
      setTimeout(() => {
        const contentWrapper = document.querySelector(
          '.v-content__wrap'
        );
        if (contentWrapper !== null) {
          contentWrapper.scrollTop = 0;
        }
        const boxedLayout = document.querySelector(
          '.app-boxed-layout .app-content'
        );
        if (boxedLayout !== null) {
          boxedLayout.scrollTop = 0;
        }
        const miniLayout = document.querySelector(
          '.app-mini-layout .app-content'
        );
        if (miniLayout !== null) {
          miniLayout.scrollTop = 0;
        }
      }, 200);
    });

    router.onError(error => {
      if (/loading chunk \w* failed./i.test(error.message)) {
        if(!process.env.VUE_APP_CORDOVA_BUILD){
          var queryParameters = new URLSearchParams(window.location.search);
          // The retry query parameter is added to prevent endless reload which might happen in certain cases
          var retry = queryParameters.get('retry');
          if(!(retry == 'true')){
            queryParameters.append('retry', 'true');
            window.location.assign(window.location.origin + window.location.pathname + `?${queryParameters}`);
          }
        }
      }
    })
  }
};
